<template>
  <div class="">
    <div class="card-body">
      <form @submit.stop.prevent="exportCalls">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="debt_statuses1" class="col-form-label">Результат разгавора</label>
              <select class="form-control form-control-sm" id="debt_statuses1" v-model="filter.debt_status_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="status in debt_statuses" :value="status.id" :key="status.id">
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="call_statuses" class="col-form-label">{{ $t('calls.call_status_name') }}</label>
              <select class="form-control form-control-sm" id="call_statuses" v-model="filter.status_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="status in call_statuses" :value="status.id" :key="status.id">
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="col-form-label">{{ $t('users.user') }}</label>
              <select class="form-control form-control-sm" v-model="filter.user_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="user in users" :value="user.id" :key="user.id">
                  {{ user.lastname }} {{ user.firstname }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="col-form-label">{{ $t('field.contragent') }}</label>
              <select class="form-control form-control-sm" v-model="filter.contragent_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="contragent in contragents" :value="contragent.id" :key="contragent.id">
                  {{ contragent.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="col-form-label" for="type_id">Направление звонков</label>
              <select class="form-control form-control-sm" id="type_id" v-model="filter.type_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="type in call_types" :value="type.id" :key="type.id">
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="col-form-label">{{ $t('calls.created_at') }}</label>
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="datestart">C</span>
                </div>
                <input type="date" class="form-control" aria-label="Small" v-model="filter.period_imported_start_date" aria-describedby="datestart" />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="col-form-label">{{ $t('calls.created_at') }}</label>
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="dateend">По</span>
                </div>
                <input type="date" class="form-control" aria-label="Small" v-model="filter.period_imported_end_date" aria-describedby="dateend" />
              </div>
            </div>
          </div>
        </div>
        <div class="block block-rounded block-fx-shadow">
          <div class="block-content row">
            <div class="col">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" @click="toggleSelectAll()" class="custom-control-input" v-model="select_all" id="selectallfields" >
                <label  class="custom-control-label" for="selectallfields" data-toggle="tooltip" data-placement="top" title="Выделить все">Поля для заголовка Excel</label>
              </div>
              <div class="custom-control custom-checkbox my-1 mr-sm-2" v-for="field in fields" :key="`calls_field_${field}`">
                <input
                    :id="`calls_field_${field}`"
                    type="checkbox"
                    class="custom-control-input"
                    :class="{'is-invalid': errors.fields && errors.fields.length > 0}"
                    v-model="filter.fields"
                    :value="field">
                <label
                    class="custom-control-label"
                    :for="`calls_field_${field}`">
                  {{ $t(`calls.${field}`)}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <button type="submit" class="btn btn-primary" name="button" :disabled="isProcessing" >
                <i class="fa fa-spinner fa-pulse fa-fw" v-if="isProcessing"></i> Выгрузить
            </button>
            <a v-if="filename && !isProcessing" :href="`${storagePath()}/exports/${filename}`" class="btn btn-success" download>
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import downloader from "js-file-download";

export default {
  data() {
    return {
      debt_statuses: [],
      call_statuses: [],
      call_types: [],
      users: [],
      contragents: [],
      filename: '',
      select_all: false,
      filter: {
        contragent_id: '',
        status_id: '',
        debt_status_id: '',
        type_id: '',
        user_id: '',
        period_imported_start_date: moment().startOf('month').format('YYYY-MM-DD'),
        period_imported_end_date: moment().endOf('month').format('YYYY-MM-DD'),
        fields: [
          'debt.number',
          'owner_fullname',
          'owner_iin',
          'phone.phone',
          'debt.contragent.name',
          'debt.last_contact',
          'comment',
          'created_at',
          'result_dialog.name',
        ]
      },
      fields: [
        'debt.number',
        'owner_fullname',
        'owner_iin',
        'who',
        'phone.phone',
        'user.fullname',
        'user.login',
        'user.team',
        'comment',
        'created_at',
        'debt.contragent.name',
        'status.name',
        'result_dialog.name',
        'type.name',
        'promisedPayment.amount',
        'promisedPayment.promised_date',
        'next_contact',
        'debt.last_contact'
      ],
      errors: {},
      isProcessing: false,
    };
  },
  mounted() {
    this.getDebtStatuses();
    this.getListUsers();
    this.getListContragents();
    this.getListCallStatuses();
    this.getListCallTypes();
  },
  methods: {
    exportCalls() {
      this.isProcessing = true;
      window.axios.post('/admin/export/calls', this.filter, {
        responseType: 'arraybuffer',
      })
          .then((res) => {
            downloader(res.data, 'calls.xlsx')
          })
          .catch((err) => {
            this.laravelValidation(err);
          })
          .finally(() => {
            this.isProcessing = false;
          });
    },
    getDebtStatuses() {
      window.axios.get('/admin/list/debt/statuses')
        .then((res) => {
          this.debt_statuses = res.data.statuses;
        });
    },
    getListUsers() {
      window.axios.get('/admin/list/users')
        .then((res) => {
          this.users = res.data.users;
        });
    },
    getListContragents() {
      window.axios.get('/admin/list/contragents')
        .then((res) => {
          this.contragents = res.data.contragents;
        });
    },
    getListCallStatuses() {
      window.axios.get('/admin/list/call/statuses')
        .then((res) => {
          this.call_statuses = res.data.statuses;
        });
    },
    getListCallTypes() {
      window.axios.get('/admin/list/call/types')
        .then((res) => {
          this.call_types = res.data.types;
        });
    },
    toggleSelectAll() {
      if (this.select_all) {
        this.filter.fields = [];
      } else {
        this.fields.forEach((field) => {
          if (!this.filter.fields.includes(field)) {
            this.filter.fields.push(field)
          }
        });
      }

      this.select_all = this.filter.fields.length === this.fields.length
    },
  },
};
</script>
